import { createReducer, on } from '@ngrx/store';
import {
  initialServiceRequestState,
  ServiceRequestState,
} from './service-request.state';

import { StateUtils } from '@state/state-utils';
import * as ServiceRequestActions from './service-request.actions';

const serviceRequestReducer = createReducer<ServiceRequestState>(
  initialServiceRequestState,

  on(ServiceRequestActions.fetchServiceRequests, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(ServiceRequestActions.fetchServiceRequestById, (state) => ({
    ...state,
    fetchedAt: null,
  })),

  on(
    ServiceRequestActions.fetchServiceRequestsSuccess,
    (state, { serviceRequests }) => ({
      ...state,
      fetchedAt: new Date(),
      serviceRequests: StateUtils.combineStateArr(
        state.serviceRequests,
        serviceRequests
      ),
    })
  ),
  on(ServiceRequestActions.fetchServiceRequestsFailed, (state) => ({
    ...state,
    fetchedAt: new Date(),
  })),

  on(
    ServiceRequestActions.fetchServiceRequestByIdSuccess,
    (state, { serviceRequest }) => ({
      ...state,
      fetchedAt: new Date(),
      serviceRequests: StateUtils.combineState(
        state.serviceRequests,
        serviceRequest
      ),
    })
  ),
  on(ServiceRequestActions.fetchServiceRequestByIdFailed, (state) => ({
    ...state,
    fetchedAt: new Date(),
  })),

  on(ServiceRequestActions.recreateServiceRequest, (state) => ({
    ...state,
    fetchedAt: null,
  })),

  on(
    ServiceRequestActions.recreateServiceRequestSuccess,
    (state, { serviceRequest }) => ({
      ...state,
      fetchedAt: new Date(),
      serviceRequests: StateUtils.combineState(
        state.serviceRequests,
        serviceRequest
      ),
    })
  ),

  on(ServiceRequestActions.recreateServiceRequestFailed, (state) => ({
    ...state,
    fetchedAt: new Date(),
  }))
);

export { serviceRequestReducer };
